export default "__VITE_ASSET__ea2b0c52__"